import { render, staticRenderFns } from "./GroupeForm.vue?vue&type=template&id=e867c7fa"
import script from "./GroupeForm.vue?vue&type=script&lang=ts"
export * from "./GroupeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports